import { UseQueryOptions, useQueryCache } from "@pinia/colada";
import { Pinia } from "pinia";

// Imperative stale-while-revalidate against the query cache, for store actions
// and bootstrap code that can't consume useQuery. Cold cache: fetches and
// waits. Warm cache: resolves immediately with the cached data and revalidates
// in the background when stale. force always fetches and waits.
// Entries are pinned (gcTime: false) because no useQuery consumer keeps them
// alive; default garbage collection would evict them out from under the
// facade getters that render them.
export async function ensureQueryData<TData>(
    options: UseQueryOptions<TData>,
    force = false,
    pinia?: Pinia
): Promise<TData | undefined> {
    const queryCache = useQueryCache(pinia);
    const entry = queryCache.ensure<TData>({ gcTime: false, ...options });

    if (force) {
        const state = await queryCache.fetch(entry);
        return state.data;
    }

    if (entry.state.value.status !== "pending") {
        void queryCache.refresh(entry).catch(() => undefined);
        return entry.state.value.data;
    }

    const state = await queryCache.refresh(entry);
    return state.data;
}

// After missing pushes (a dropped socket), every cached answer is suspect. On-screen queries
// refetch now; the rest are marked stale and refetch when next used.
export function refetchAllServerState(pinia?: Pinia) {
    void useQueryCache(pinia).invalidateQueries();
}
